export default "__VITE_ASSET__9fba0066__"